<template>
  <!-- <v-container class="mt-4 pa-0"> -->
  <div>
    <v-layout justify-center>
      <v-flex xs12 md12 lg12>
        <v-card color="primary" class="elevation-1" v-if="!!repair.length">
          <v-toolbar color="primary" flat>
            <v-tooltip bottom>
              <v-btn color="secondary" outline slot="activator" @click="reset()" class="ml-4 mt-3">
                <v-icon left>arrow_back</v-icon>
                GO BACK
              </v-btn>
              <span>Go Home</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <ProcessFlow class="mt-4" :states="states" :current-state="computeState"></ProcessFlow>
          </v-toolbar>
          <v-toolbar color="primary" flat>

            <v-btn v-if="repair[0].state == 'draft'" text class="mt-3  ml-4" @click="completeRepair()"
              color="secondary">Complete Repair</v-btn>
            <v-btn v-if="repair[0].state == 'done'" text class="mt-3" @click="undoRepair()" color="secondary">Undo
              Repair</v-btn>
            <v-btn v-if="repair[0].state == 'draft'" text class="mt-3" @click="scrapRepair()" color="error">Scrap
              Repair</v-btn>

            <v-btn text class="mt-3" @click="printDialog = true">Print Label</v-btn>
          </v-toolbar>

          <v-layout row wrap class="ml-4 mt-3">
            <v-flex class="ml-4" xs6 style="border-left: 1px solid">
              <v-card-text>

                <h3>Repair Reference</h3>
                <h1 class="mb-4 repair-title" style="color: #F04E23;">
                  <v-text-field style="width:350px; margin-top: -2px; margin-bottom: -12px;" class="repair-title"
                    color="secondary" v-model="repairName" :disabled="repair[0].state == 'done'"></v-text-field>
                </h1>

                <v-text-field label="Device Serial Number" style="width:200px; margin-top: -12px; margin-bottom: -12px;"
                  color="secondary" v-model="serialNumber" :disabled="repair[0].state == 'done'"></v-text-field>
                <v-text-field label="IMEI/MEID" style="width:200px; margin-top: -12px; margin-bottom: -12px;"
                  color="secondary" v-model="imei" :disabled="repair[0].state == 'done'"></v-text-field>
                <v-text-field label="ICCID" style="width:200px; margin-top: -12px; margin-bottom: -12px;"
                  color="secondary" v-model="iccid" :disabled="repair[0].state == 'done'"></v-text-field>
                <v-text-field label="Model Number" style="width:200px; margin-top: -12px; margin-bottom: -12px;"
                  color="secondary" v-model="modelNumber" :disabled="repair[0].state == 'done'"></v-text-field>
                <v-text-field label="Storage Amount" style="width:200px; margin-top: -12px; margin-bottom: -12px;"
                  color="secondary" v-model="storageAmount" :disabled="repair[0].state == 'done'"></v-text-field>
                <v-text-field label="Carrier Status" style="width:200px; margin-top: -12px;" color="secondary"
                  v-model="carrierStatus" :disabled="repair[0].state == 'done'"></v-text-field>

                <v-btn color="secondary" @click="updateRepair" :disabled="repair[0].state == 'done'">Save
                  Changes</v-btn>
              </v-card-text>
            </v-flex>


            <v-flex xs5 style="border-right: 1px solid">
              <v-card-text>
                <h3>Status</h3>
                <h1 class="mb-4" :style="{ color: getColor(repair[0].x_mrp_passed) }">{{ repair[0].x_mrp_passed }}</h1>
                <h3>Product to Repair</h3>
                <h3 class="mb-4">{{ repair[0].product_id[1] }}</h3>
                <h4>Lot/Serial</h4>
                <h3 class="mb-4 repair-title">{{ repair[0].lot_id[1] }}</h3>
                <h4>Customer/Owner</h4>
                <h3 class="mb-4">{{ repair[0].partner_id[1] }}</h3>

                <v-checkbox color="secondary" label="Awaiting Parts" v-model="awaitingParts"
                  :disabled="repair[0].state == 'done'"></v-checkbox>



                <!-- 
                <h4>Current Location</h4>
                <h2 class="mb-4">{{ repair[0].location_id[1] }}</h2>

                <h4>Destination Location</h4>
                <h2 class="mb-4">{{ repair[0].location_dest_id[1] }}</h2> -->
              </v-card-text>
            </v-flex>
          </v-layout>

          <v-tabs v-model="activeTab" class="odoo-tabs ml-4 mt-3" slider-color="secondary" color="primary">
            <v-tab href="#parts">Parts</v-tab>
            <v-tab href="#operations">Operations</v-tab>
            <v-tab href="#disposition">Disposition</v-tab>

            <!-- PARTS -->
            <v-tab-item value="parts">
              <v-layout row wrap class="mt-3">
                <v-card flat class="tab-card" color="primary">
                  <v-card-text class="pa-0">
                    <v-data-table :headers="partsHeaders" :items="parts" class="elevation-0" hide-actions flat
                      :no-data-text="' '">
                      <template v-slot:headers="{ headers }">
                        <tr>
                          <th v-for="h in headers" :key="h.text" class="odoo-th">{{ h.text }}</th>
                        </tr>
                      </template>

                      <template v-slot:items="{ item }">
                        <tr>
                          <td class="text-capitalize">{{ item.type }}</td>
                          <td>{{ item.product_id[1] }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.x_owner_id[1] }}</td>
                          <td>{{ item.lot_id[1] }}</td>
                          <td>{{ item.location_id[1] }}</td>
                          <td class="text-right">{{ item.product_uom_qty }}</td>
                          <td>
                            <v-icon :disabled="repair[0].state == 'done'" small
                              @click="deletePart(item.id)">delete</v-icon>
                          </td>
                        </tr>
                      </template>

                      <!-- <template v-slot:footer>
                          <div class="d-flex justify-end py-3 pr-3">
                            <div class="odoo-total">
                              <span class="mr-3 grey--text text--darken-1">Total:</span>
                              <strong>{{ partsTotal }}</strong>
                            </div>
                          </div>
                        </template> -->
                    </v-data-table>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn small outline color="secondary" @click="openParts" v-show="repair[0].state == 'draft'">Add
                      Part</v-btn>
                  </v-card-actions>
                </v-card>
              </v-layout>
            </v-tab-item>

            <!-- OPERATIONS -->
            <v-tab-item value="operations">
              <v-layout row wrap class="mt-3">
                <v-card flat class="tab-card" color="primary">
                  <v-card-text class="pa-0">
                    <v-data-table :headers="opHeaders" :items="operations" class="elevation-0" hide-actions
                      :no-data-text="' '">
                      <template v-slot:headers="{ headers }">
                        <tr>
                          <th v-for="h in headers" :key="h.text" class="odoo-th">{{ h.text }}</th>
                        </tr>
                      </template>

                      <template v-slot:items="{ item }">
                        <tr>
                          <td>{{ item.product_id[1] }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ localizeOdooDate(item.create_date, true) }}</td>
                          <td>{{ item.x_result }}</td>
                          <td>{{ item.x_completed_by }}</td>
                          <td>
                            <div v-if="item.x_reason_ids && item.x_reason_ids.length">
                              <v-chip v-for="reason in item.x_reason_ids" :key="reason[0]" class="ma-1" small
                                color="secondary" dark>
                                {{failureTags.find(tag => tag.id === reason).label || 'Unknown Reason'}}
                              </v-chip>
                            </div>
                          </td>
                          <td>
                            <v-icon :disabled="repair[0].state == 'done'" small
                              @click="deleteOperation(item.id)">delete</v-icon>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn small outline color="secondary" v-show="repair[0].state == 'draft'"
                      @click="openOperations">Add
                      operation</v-btn>
                  </v-card-actions>
                </v-card>
              </v-layout>
            </v-tab-item>

            <!-- DISPOSITION -->
            <v-tab-item value="disposition">
              <v-layout row wrap class="mt-3">
                <v-flex xs6>
                  <v-card flat class="tab-card" color="primary">
                    <v-select :items="conditions" class="my-2" v-model="finalCondition" label="Final Condition"
                      color="secondary" item-text="name" item-value="id" :disabled="repair[0].state == 'done'" />
                    <v-select :items="colors" class="my-2" v-model="finalColor" label="Final Color" color="secondary"
                      hide-details :disabled="repair[0].state == 'done'" item-text="name" item-value="id" />
                    <v-autocomplete v-model="finishedProduct" :items="finishedProducts"
                      :search-input.sync="finishedProductSearch" item-text="name" item-value="id" color="secondary"
                      label="Finished Product" class="my-2" hide-details
                      :disabled="repair[0].state == 'done'"></v-autocomplete>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Add Parts Dialog -->
    <v-dialog v-model="partDialog" :width="dialogWidth" transition="dialog-transition" persistent>
      <v-card color="primary" style="height: 400px">
        <v-card-title class="headline">Add Part</v-card-title>
        <v-card-text>
          <v-autocomplete v-model="partsProduct" :items="partsProducts" item-text="name" item-value="id"
            color="secondary" label="Finished Product" class="my-2" hide-details></v-autocomplete>
        </v-card-text>
        <v-card-actions style="position: absolute; bottom: 0; right: 0;">
          <v-spacer></v-spacer>
          <v-btn color="secondary" flat @click="partDialog = false">Cancel</v-btn>
          <v-btn color="secondary" flat @click="addPart">Add Part</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add Operations Dialog -->
    <v-dialog v-model="operationsDialog" :width="dialogWidth" transition="dialog-transition" persistent>
      <v-card color="primary" style="height: 400px">
        <v-card-title class="headline">Add Operation</v-card-title>
        <v-card-text>
          <v-autocomplete v-model="operationProduct" :items="operationProducts" item-text="name" item-value="id"
            color="secondary" label="Operation Product" class="my-2" hide-details></v-autocomplete>
          <v-select v-show="[743, 199746].includes(operationProduct)" :items="['Passed', 'Failed']" class="my-2 "
            v-model="operationResult" label="Result" color="secondary" item-text="name" item-value="name" />
          <v-autocomplete v-show="operationResult === 'Failed' && operationProduct == 743" :items="failureTags"
            class="my-2" v-model="operationFaultCodes" label="Fault Codes" color="secondary" item-text="label"
            item-value="id" :search-input.sync="faultCodeSearch" @change="faultCodeSearch = ''" multiple />
        </v-card-text>

        <v-card-actions style="position: absolute; bottom: 0; right: 0;">
          <v-spacer></v-spacer>
          <v-btn color="secondary" flat @click="operationsDialog = false">Cancel</v-btn>
          <v-btn color="secondary" flat @click="addOperation">Add Operation</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showPopup" width="450px" persistent>
      <v-card color="primary">
        <v-card-title class="headline">{{ popupTitle }}</v-card-title>
        <v-card-text>
          <div v-html="popupHtml"></div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" flat @click="showPopup = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="printDialog" :width="dialogWidth" transition="dialog-transition">
      <v-card color="primary" style="height: 400px">
        <v-card-title class="headline">Print Label</v-card-title>
        <v-card-text>
          <v-select :items="allPrinters" v-model="selectedPrinter" color="secondary" label="Select Printer" box
            :style="{ width: '50%', margin: 'auto' }"></v-select>

          <v-select :items="['medium', 'small']" v-model="selectedSize" color="secondary" label="Select Label Size" box
            :style="{ width: '50%', margin: 'auto' }"></v-select>
        </v-card-text>
        <v-card-actions style="position: absolute; bottom: 0; right: 0;">
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="printLabel()">Print Label</v-btn>
          <v-btn color="secondary" flat @click="printDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  <!-- </v-container> -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";
import Common from "@/mixins/Common";
import ProcessFlow from "@/components/app/ProcessFlow";
import { repair } from "../../store/modules/repair.module";

export default {
  name: "repair-model",

  data() {
    return {
      passed: false,
      failed: false,
      cleaning: false,
      packing: false,
      editName: false,
      failureDialog: false,
      preCleaningStart: false,
      repairStart: false,
      beginStep: false,
      scanCount: 0,
      time: 1,
      timeInterval: false,
      failureReasons: false,
      repairName: "",
      imei: "",
      iccid: "",
      modelNumber: "",
      serialNumber: "",
      storageAmount: "",
      carrierStatus: "",
      showPopup: false,
      awaitingParts: false,
      popupTitle: "",
      popupHtml: "",
      activeTab: 'parts',
      partsProducts: [],
      partsProduct: null,
      partProductSearch: '',
      partsHeaders: [
        { text: 'Type', value: 'type' },
        { text: 'Product', value: 'product_id' },
        { text: 'Description', value: 'name' },
        { text: 'Owner', value: 'x_owner_id' },
        { text: 'Lot/Serial', value: 'lot_id' },
        { text: 'Source Location', value: 'location_id' },
        { text: 'Quantity', value: 'product_uom_qty', align: 'right' },
        { text: 'Actions' }
      ],

      parts: [],

      opHeaders: [
        { text: 'Product', value: 'product_id' },
        { text: 'Description', value: 'name' },
        { text: 'Performed On', value: 'create_date' },
        { text: 'Result', value: 'x_result' },
        { text: 'Completed By', value: 'x_completed_by' },
        { text: 'Fault Codes', value: 'x_reason_ids' },
        { text: 'Actions' }
      ],
      operations: [],

      // Disposition form data
      conditions: [{ "id": 3, "name": "New", "attribute_id": [2, "Condition"], "sequence": 0 }, { "id": 1526, "name": "Used", "attribute_id": [2, "Condition"], "sequence": 1 }, { "id": 465, "name": "Failed", "attribute_id": [2, "Condition"], "sequence": 3 }, { "id": 4, "name": "Pre-Owned", "attribute_id": [2, "Condition"], "sequence": 4 }, { "id": 5, "name": "Refurbished", "attribute_id": [2, "Condition"], "sequence": 5 }, { "id": 16, "name": "Scratch and Dent", "attribute_id": [2, "Condition"], "sequence": 6 }, { "id": 6, "name": "Certified Refurbished", "attribute_id": [2, "Condition"], "sequence": 6 }, { "id": 809, "name": "New, Open Box", "attribute_id": [2, "Condition"], "sequence": 8 }, { "id": 1527, "name": "TF", "attribute_id": [2, "Condition"], "sequence": 9 }],
      colors: [],
      finishedProducts: [],
      states: ['Quotation', 'Under Repair', 'Repaired'],

      finalCondition: null,
      finalColor: null,
      finishedProduct: null,

      partDialog: false,
      partToAdd: null,
      partProduct: null,

      operationsDialog: false,
      operationProduct: null,
      operationProducts: [],
      operationProductSearch: '',
      operationResult: null,
      operationFaultCodes: [],

      faultCodeSearch: '',

      printDialog: false,

      timeout: null,
      finishedProductSearch: '',

    };
  },

  mixins: [LoginCheck, Common],

  components: {
    ProcessFlow
  },

  async beforeMount() {
    await this.setValues();
    await this.getAllPrinters();
  },

  destroyed() {
    this.$store.commit("repair/setRepair", []);
  },

  computed: {
    ...mapGetters({
      repair: "repair/getRepair",
      failureTags: "repair/getFailureTags",
      repairOperations: "repair/getRepairOperations",
      repairParts: "repair/getRepairParts",
      productAttributes: "productAttribute/getAttributes",
      allPrinters: "repair/getAllPrinters",
      storedPrinter: "repair/getSelectedPrinter",
      storedPrintSize: "repair/getStoredPrintSize",
      foundProduct: "product/getProduct",
    }),
    selectedPrinter: {
      get() {
        return this.storedPrinter;
      },
      set(val) {
        return this.$store.commit("repair/setSelectedPrinter", val);
      },
    },

    selectedSize: {
      get() {
        return this.storedPrintSize;
      },
      set(val) {
        console.log('Setting stored print size to:', val);
        return this.$store.commit("repair/setStoredPrintSize", val);
      },
    },

    dialogWidth() {
      if (this.$vuetify.breakpoint.xs) {
        return "100%";
      } else if (this.$vuetify.breakpoint.sm) {
        return "80%";
      } else return "50%";
    },

    computeState() {
      switch (this.repair[0].state) {
        case "draft":
          return "Quotation";
        case "confirmed":
          return "Confirmed";
        case "under_repair":
          return "Under Repair";
        case "done":
          return "Repaired";
      }
    }
  },

  watch: {
    async finalCondition(value) {
      if (!this.repair.length) return;
      const bindle = await this.getRepairDispositionValues({
        product_id: this.repair[0].product_id[0],
        condition: value
      });
      this.finalColor = null
      this.finishedProduct = null
      this.colors = bindle.x_color
      this.finishedProducts = bindle.x_finished_product
    },

    async finalColor(value) {
      if (!this.repair.length) return;
      const bindle = await this.getRepairDispositionValues({
        product_id: this.repair[0].product_id[0],
        condition: this.finalCondition,
        color: value
      });
      this.finishedProducts = bindle.x_finished_product
    },

    async finishedProductSearch(value) {
      if (this.finalCondition || this.finalColor) {
        this.finishedProductSearch = value
        return
      }

      this.finishedProductSearch = value
      clearTimeout(this.timeout)

      if (!value || value.length < 3) {
        this.finishedProducts = []
        return
      }
      this.timeout = setTimeout(async () => {
        const bindle = await this.productSearch({
          body: {
            kwargs: {
              product: value,
              id: false
            }
          }
        });
        if (!bindle || !bindle.length) {
          this.finishedProducts = []
          return
        }
        this.finishedProducts = bindle.map(p => ({
          id: p.id,
          name: p.display_name
        }));
      }, 400)
    },
  },

  methods: {
    ...mapActions({
      showSnackbar: "app/setSnackbar",
      repairSearch: "repair/searchServices",
      addOperationToRepair: "repair/addOperation",
      getFailureTags: "repair/getFailureTags",
      storeUpdateRepair: "repair/updateRepair",
      storeCompleteRepair: "repair/completeRepair",
      storeUndoRepair: "repair/undoRepair",
      storeScrapRepair: "repair/scrapRepair",
      getRepairOperations: "repair/getRepairOperations",
      getRepairParts: "repair/getRepairParts",
      getProductAttributes: "productAttribute/search",
      getRepairDispositionValues: "productAttribute/getRepairDispositionValues",
      productSearch: "product/search",
      productSearchOdoo: "product/searchOdoo",
      searchQuant: "inventory/searchQuant",
      addPartToRepair: "repair/addPartToRepair",
      storeDeleteOperation: "repair/deleteOperation",
      storeDeletePart: "repair/deletePart",
      getAllPrinters: "repair/getAllPrinters",
      printProductLabel: "repair/printProductLabel",
      update: "stockLot/update",
    }),

    async completeRepair() {
      if (!await this.updateRepair()) return;
      if (!this.finishedProduct) {
        this.showSnackbar({
          text: 'Please select a Finished Product before completing the repair.',
          color: 'red'
        });
        return;
      }

      const res = await this.storeCompleteRepair(this.repair[0].id);
      if (res.error) {
        if (res.error) {
          this.popupTitle = 'Repair Error'
          this.popupHtml = this.formatRepairError(res.error)
          this.showPopup = true
          return
        }
      }
      await this.setValues();
    },


    async undoRepair() {
      if (confirm("Are you sure you want to undo this repair?")) {
        const res = await this.storeUndoRepair(this.repair[0].id);
        if (res.error) {
          if (res.error) {
            this.popupTitle = 'Undo Repair Error'
            this.popupHtml = this.formatRepairError(res.error)
            this.showPopup = true
            return
          }
        }
        await this.setValues();
      }
    },

    async scrapRepair() {
      if (confirm("Are you sure you want to scrap this repair? This action cannot be undone.")) {
        const res = await this.storeScrapRepair(this.repair[0].id);
        if (res.error) {
          if (res.error) {
            this.popupTitle = 'Scrap Repair Error'
            this.popupHtml = this.formatRepairError(res.error)
            this.showPopup = true
            return
          }
        }
        await this.setValues();
      }
    },


    async updateRepair() {
      if (this.imei && this.imei.length < 15) {
        this.showSnackbar({
          text: 'IMEI/MEID must be at least 15 characters long.',
          color: 'red'
        });
        return false;
      }

      if (!this.finalColor && this.finishedProduct && this.finalCondition) {
        this.finalColor = 2;
      }

      const payload = {
        id: this.repair[0].id,
        name: this.repairName,
        x_imei: this.imei,
        x_iccid: this.iccid,
        x_model_number: this.modelNumber,
        x_device_serial_number: this.serialNumber,
        x_device_storage: this.storageAmount,
        x_carrier_status: this.carrierStatus,
        x_condition: this.finalCondition,
        x_color: this.finalColor,
        x_finished_product: this.finishedProduct,
        x_awaiting_parts: this.awaitingParts,
      };

      if (!this.imei) {
        delete payload.x_imei;
      }  

      await this.storeUpdateRepair({ body: payload });
      if (payload.name != this.repair[0].name) {
        await this.update({
          body: { id: this.repair[0].lot_id[0], name: payload.name }
        });
        this.$router.replace({ params: { serial: payload.name } });
      }
      await this.setValues();
      return true;
    },

    async openParts() {
      this.partDialog = true;
      let partsSearch = [
        {
            field: "location_id.complete_name",
            operator: "ilike",
            value: 'repair'
          }
      ]
      if (this.repair[0].product_id[0] == 117448) {
        partsSearch.push(
          {
            field:"product_id.x_vendor_sku",
            operator: "=",
            value: "AIRPODMAX"
          }
        )
      }

      if (this.repair[0].product_id[0] == 427677 || this.repair[0].product_id[0] == 427678) {
        partsSearch.push(
          {
            field:"product_id.x_vendor_sku",
            operator: "=",
            value: "OURA"
          }
        )
      }

      

      const parts = await this.searchQuant(
        partsSearch
      );

      this.partsProducts = parts.map(part => ({
        id: part.product_id[0],
        name: part.product_id[1]
      }));
    },

    async openOperations() {
      this.operationsDialog = true;
      const bindle = await this.productSearchOdoo([
        {
          field: "id",
          operator: "in",
          value: [743, 199746, 745, 343, 417662, 343603, 39246, 275208, 275207, ]
        }
      ]);
      this.operationProducts = bindle.map(op => ({
        id: op.id,
        name: op.display_name
      })).sort((a, b) => a.id - b.id);
    },

    deleteOperation(id) {
      if (confirm("Are you sure you want to delete this operation?")) {
        this.storeDeleteOperation({ id })
        this.setValues();
      }
    },

    deletePart(id) {
      if (confirm("Are you sure you want to delete this part?")) {
        this.storeDeletePart({ id })
        this.setValues();
      }
    },

    async printLabel() {
      try {
        if (!this.selectedPrinter) {
          this.showSnackbar({
            text: 'Please select a printer before printing.',
            color: 'red'
          });
          return;
        }
        if (!this.selectedSize) {
          this.showSnackbar({
            text: 'Please select a label size before printing.',
            color: 'red'
          });
          return;
        }

        if (this.repair[0].state != 'done') {
          await this.productSearch({
            body: {
              kwargs: {
                product: false,
                id: this.repair[0].product_id[0]
              }
            }
          })
        } else {
          await this.productSearch({
            body: {
              kwargs: {
                product: false,
                id: this.repair[0].x_finished_product[0]
              }
            }
          });
        }

        const payload = {
          printer: this.selectedPrinter,
          sn: this.repair[0].name,
          sku: this.foundProduct[0].default_code,
          barcode: this.foundProduct[0].barcode,
          description: this.foundProduct[0].x_sales_description || this.foundProduct[0].display_name,
          owner: this.repair[0].x_customer_code,
          size: this.selectedSize
        };

        await this.printProductLabel(payload);

        this.printDialog = false;
        this.showSnackbar({
          text: 'Label sent to printer.',
          color: 'green'
        });
      } catch (error) {
        console.error('Error printing label:', error);
        this.showSnackbar({
          text: 'Error printing label. Please try again.',
          color: 'red'
        });
      }
    },


    formatRepairError(raw) {
      let s = String(raw).replace(/^"\s*|\s*"$/g, '')
      const lines = s.split('\n').map(l => l.trim()).filter(Boolean)
      const intro = lines.shift() || 'There was a validation error.'
      const bullets = []
      const extra = []

      for (const line of lines) {
        if (/^-\s*/.test(line)) {
          bullets.push(line.replace(/^-\s*/, ''))
        } else {
          extra.push(line)
        }
      }

      const esc = (t) => t
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')

      const introHtml = `<p>${esc(intro)}</p>`
      const bulletsHtml = bullets.length
        ? `<ul style="margin-left:1rem">${bullets.map(b => `<li>${esc(b)}</li>`).join('')}</ul>`
        : ''
      const extraHtml = extra.length
        ? `<pre style="white-space:pre-wrap;margin:0">${esc(extra.join('\n'))}</pre>`
        : ''
      return `<div>${introHtml}${bulletsHtml}${extraHtml}</div>`
    },




    async setValues() {
      await this.repairSearch({ serial: this.$route.params.serial });
      await this.getRepairOperations({ id: this.repair[0].id });
      await this.getRepairParts({ id: this.repair[0].id });
      await this.getFailureTags();

      this.operations = this.repairOperations
      this.parts = this.repairParts;
      this.repairName = this.repair[0].name ? this.repair[0].name : "";
      this.imei = this.repair[0].x_imei ? this.repair[0].x_imei : "";
      this.iccid = this.repair[0].x_iccid ? this.repair[0].x_iccid : "";
      this.modelNumber = this.repair[0].x_model_number ? this.repair[0].x_model_number : "";
      this.serialNumber = this.repair[0].x_device_serial_number ? this.repair[0].x_device_serial_number : "";
      this.storageAmount = this.repair[0].x_device_storage ? this.repair[0].x_device_storage : "";
      this.carrierStatus = this.repair[0].x_carrier_status ? this.repair[0].x_carrier_status : "";
      this.awaitingParts = this.repair[0].x_awaiting_parts


      this.finalCondition = this.repair[0].x_condition ? this.repair[0].x_condition[0] : null;
      if (this.repair[0].x_color) {
        this.colors = [{
          id: this.repair[0].x_color[0],
          name: this.repair[0].x_color[1]
        }]
        this.finalColor = this.repair[0].x_color[0];
      }
      if (this.repair[0].x_finished_product) {
        this.finishedProducts = [{
          id: this.repair[0].x_finished_product[0],
          name: this.repair[0].x_finished_product[1]
        }];
        this.finishedProduct = this.repair[0].x_finished_product[0];
      }
    },

    getColor(status) {
      let color = "";
      switch (status.toLowerCase()) {
        case "incomplete":
          color = "yellow";
          break;
        case "passed":
          color = "green";
          break;
        case "failed":
          color = "red";
          break;
        default:
          break;
      }
      return color;
    },


    async addPart() {
      this.addPartToRepair({
        repairID: this.repair[0].id,
        productID: this.partsProduct,
      });
      let activeTab = this.activeTab;
      this.setValues();
      Object.assign(this.$data, this.$options.data.apply(this));
      this.activeTab = activeTab;
    },

    async addOperation() {
      let body = {
        repairID: this.repair[0].id
      }

      if (this.operationProduct == 743) {
        body.step = 'Testing'
        if (this.operationResult.toLowerCase() != 'passed') {
          body.failureReasons = this.operationFaultCodes
          body.passed = false
        }
      } else if (this.operationProduct == 745) {
        body.step = 'packaging'
      } else if (this.operationProduct == 39246) {
        body.step = 'packaging-o'
      } else if (this.operationProduct == 199746) {
        body.step = 'wiping';
        if (this.operationResult.toLowerCase() != 'passed') {
          body.passed = false
        }
      } else if (this.operationProduct == 343603) {
        body.step = 'labeling'
      } else if (this.operationProduct == 275207) {
        body.step = 'g35'
      } else if (this.operationProduct == 275208) {
        body.step = 'g100'
      } else if (this.operationProduct == 417662) {
        body.step = 'battery'
      }

      await this.addOperationToRepair(body);


      let activeTab = this.activeTab;
      this.setValues();
      Object.assign(this.$data, this.$options.data.apply(this));
      this.activeTab = activeTab;
    },

    reset() {
      this.$store.commit("repair/setRepair", []);
      this.$store.commit("repair/setRepairOperations", []);
      Object.assign(this.$data, this.$options.data.apply(this));
      this.$router.push("/repair");
    },


  }
};
</script>

<style>
.confirm-button {
  height: 50px;
  width: 50%;
  margin: auto;
  font-size: 24px;
}

.repair-title .v-input__slot input {
  font-size: 24px;
  color: #F04E23 !important;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.odoo-th {
  text-align: left;
}

.tab-card {
  width: 10%;
  height: 500px;
  min-width: 90%;
}
</style>
